import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogActions from "@mui/material/DialogActions";
import * as XLSX from "xlsx";
import { makeStyles } from "@mui/styles";
import { useMsal } from "@azure/msal-react";
import AlertService from "../../../../services/console_services/Alerts";
import { formatColumnValue } from "../../../hooks/Formatter";
import { connect } from "react-redux";
import Loading from "../../Loading";
import { useSelector } from "react-redux";

const BootstrapDialog = styled(Dialog)(({ _theme }) => ({
  "& .MuiDialog-paper": {
    width: "60%",
    maxWidth: "none",
    borderRadius: 12,
  },
}));

const useStyles = makeStyles({
  dialogTitle: {
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: "space-between !important",
  },
  editTitle: {
    fontSize: "15px !important",
    fontWeight: "600 !important",
  },
  dialogContent: {
    display: "flex !important",
    justifyContent: "space-between !important",
    alignItems: "center !important",
  },
  fileDiv: {
    marginRight: "50px",
  },
  formContainer: {
    margin: "30px 0px !important",
  },
  formField: {
    marginBottom: "10px !important",
    fontSize: "13px !important",
  },
  textField: {
    width: "350px",
    "& .MuiInputBase-input": {
      height: "15px !important",
      borderRadius: "4px !important",
      fontSize: "12px !important",
      borderColor: "transparent !important",
    },
  },
  dottedBox: {
    border: "2px dashed #9294974d !important",
    padding: "50px !important",
    textAlign: "center !important",
    cursor: "pointer !important",
  },
  draggingDottedBox: {
    border: "2px dashed #054E9C !important",
  },
  fileUploadedIcon: {
    color: "#008000a8 !important",
    fontSize: "50px !important",
  },
  drapDrop: {
    fontSize: "12px !important",
    marginTop: "5px",
    marginBottom: "5px",
  },
  fileUploadedText: {
    fontSize: "13px !important",
    marginTop: "5px !important",
    marginBottom: "5px !important",
  },
  fileNameText: {
    fontSize: "13px !important",
    textDecoration: "underline !important",
    cursor: "pointer !important",
    fontWeight: "600 !important",
    color: "#0505868c !important",
  },
  browseFilesButton: {
    fontSize: "12px !important",
    color: "red !important",
    textTransform: "none !important",
    padding: "6px 12px !important",
  },
  dialogActions: {
    display: "flex !important",
    alignItems: "center !important",
    marginRight: "16px !important",
    padding: "16px !important",
  },
  cancelButton: {
    background: "#FFF !important",
    color: "black !important",
    margin: "0px 10px",
    fontSize: "12px !important",
    textTransform: "none !important",
  },
  saveButton: {
    background: "#054E9C !important",
    color: "#FFF !important",
    fontSize: "11px !important",
    textTransform: "none !important",
  },
  uploadIcon: {
    color: "#9294974d !important",
    fontSize: "32px !important",
  },
  or: {
    fontSize: "12px !important",
    marginBottom: "5px",
  },
  viewUploadButton: {
    marginTop: "20px",
    textAlign: "center",
    width: "100%",
  },
  viewButton: {
    fontSize: "12px !important",
    color: "black !important",
    border: "1px solid black",
    borderRadius: "8px",
    textTransform: "none !important",
  },
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "200px",
  },
});

function BulkEdit({
  openBulkEdit,
  handleBulkEditClose,
  handleSave,
  _payloadIncrease,
  _costReduction,
  _payloadDecrease,
  _setPayloadIncrease,
  _setCostReduction,
  _setPayloadDecrease,
  Network,
  DC,
  _PL3,
  _Division,
  _Products,
  _date,
  _role,
  setOnsave,
  onFileData,
  _editAlertLoading,
  setEditAlertLoading,
}) {
  const classes = useStyles();
  const { instance } = useMsal();
  // const [fileContent, setFileContent] = useState("");
  const [fileName, setFileName] = useState("");
  const [dragging, setDragging] = useState(false);
  const [alertValues, setAlertValues] = useState({});
  const [fileData, setFileData] = useState([]);
  const [alertType, setAlertType] = useState([]);
  const [alertFile, setalertFile] = useState(-1);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const hasInputValues = Object.values(alertValues).some(
    (value) => value !== ""
  );
  const { tabName } = useSelector((state) => state?.tabs);
  var apiValue = tabName;

  if (tabName === "Deployment Optimization") {
    apiValue = "DO";
  } else if (tabName === "Deployment Planning") {
    apiValue = "DP";
  } else if (tabName === "FG Salvage") {
    apiValue = "FGS";
  } else if (tabName === "Capacity Planning") {
    apiValue = "CP";
  } else if (tabName === "Distribution_Planning") {
    apiValue = "DIP";
  } else if (tabName === "Potential Out Of Stock") {
    apiValue = "POOS";
  } else if (tabName === "RR") {
    apiValue = "RR";
  } else if (tabName === "Network Planning Simulation") {
    apiValue = "NPS";
  }

  const handleInputChange = (e, key) => {
    setAlertValues((prevValues) => ({
      ...prevValues,
      [key]: e.target.value,
    }));
    setalertFile(0);
  };

  const handleFileRead = (e) => {
    const content = e.target.result;
    // setFileContent(content);

    const workbook = XLSX.read(content, { type: "binary" });
    const sheetName = workbook.SheetNames[0];
    const sheet = workbook.Sheets[sheetName];
    const headers = {};
    const range = XLSX.utils.decode_range(sheet["!ref"]);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = { c: C, r: range.s.r };
      const cellRef = XLSX.utils.encode_cell(cellAddress);
      const cell = sheet[cellRef];
      if (cell && cell.t) {
        headers[C] = cell.v;
      }
    }
    const data = [];
    for (let R = range.s.r + 1; R <= range.e.r; ++R) {
      const row = {};
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = { c: C, r: R };
        const cellRef = XLSX.utils.encode_cell(cellAddress);
        const cell = sheet[cellRef];
        if (cell) {
          row[headers[C]] = cell.v;
        }
      }
      data.push(row);
    }
    setFileData(data);
  };

  const bulkEditThresholdFileUpload = (filter) => {
    const params = {
      file: fileData,
      ...filter,
    };

    AlertService.bulkEditThresholdFileUpload(params, instance)
      .then((response) => {
        // setFileContent("");
        setFileName("");
        console.log("File upload successful:", response);
      })
      .catch((error) => console.error("Error:", error));
  };
  const MAX_FILE_SIZE = 5 * 1024 * 1024;

  const handleFileChosen = (file) => {
    setErrorMessage("");
    if (file.size > MAX_FILE_SIZE) {
      setErrorMessage("File size exceeds 5MB. Please select a smaller file.");
      return;
    }
    if (
      file.type === "text/csv" ||
      file.type === "application/vnd.ms-excel" ||
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      const fileReader = new FileReader();
      fileReader.onloadend = (e) => {
        handleFileRead(e);
      };

      if (file.type === "text/csv") {
        fileReader.readAsText(file);
      } else {
        fileReader.readAsBinaryString(file);
      }

      setFileName(file.name);
      setalertFile(1);
      setDragging(false);
    } else {
      console.log("Please select a .csv or Excel file.");
    }
  };

  const handleRemoveFile = () => {
    // setFileContent("");
    setFileName("");
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);

    if (e.dataTransfer.files.length > 0) {
      handleFileChosen(e.dataTransfer.files[0]);
    }
  };

  const handleClose = () => {
    handleBulkEditClose();
    // setAlertType([]);
    setErrorMessage();
  };

  /**
   * @param {Object} alertValues - Object containing alert values.
   * @param {string} Network - Network value for filtering.
   * @param {string} DC - Data Center value for filtering.
   * @returns {Object} - The generated parameters including filter and alerts.
   */
  function generateParams(alertValues, Network, DC) {
    const params = { filter: {}, module: apiValue };
    let filter = {};
    if (Network) {
      filter.Network = Network;
    } else if (DC) {
      filter.RecommendedDC = DC;
    }
    if (Object.keys(filter).length > 0) {
      params.filter = filter;
    }
    const alertAndThreshold = [];
    const addAlert = (type, value) => {
      if (value !== undefined) {
        alertAndThreshold.push({ alertType: type, thresholdValue: value });
      }
    };

    addAlert("COF_Increase", alertValues.COF_Increase);
    addAlert("Cost_Reduction", alertValues.Cost_reduction);
    addAlert("cost_per_case", alertValues.cost_per_case_increase);
    addAlert("cost_reduction", alertValues.Cost_Reduction);
    addAlert("truckloads_projected", alertValues.Truckloads_Projected);
    addAlert("payload_decrease", alertValues.Payload_reduction);
    addAlert("below_min_count", alertValues.Below_Min_Count);
    addAlert("stockout_count", alertValues.Stockout_Count);
    addAlert("saving_opportunity", alertValues["Saving Opportunity"]);
    addAlert("waste_risk", alertValues["Waste Risk"]);

    addAlert("throughput", alertValues.Throughput);
    addAlert("lt_under_utilization", alertValues["LT-Under Utilization"]);
    addAlert("lt_over_utilization", alertValues["LT-Over Utilization"]);
    addAlert("st_under_utilization", alertValues["ST-Under Utilization"]);
    addAlert("st_over_utilization", alertValues["ST-Over Utilization"]);
    //addAlert("waste_risk", alertValues["Waste Risk"]); Already added same above
    addAlert(
      "Incident rate increase MoM",
      alertValues["Incident rate increase MoM"]
    );
    addAlert(
      "Incident rate increase WoW",
      alertValues["Incident rate increase WoW"]
    );
    addAlert("Pending action > 2 days", alertValues["Pending action > 2 days"]);
    addAlert("r_poos_pending_review", alertValues["RPOOS-Pending Review"]);
    addAlert("n_poos_reject", alertValues["NPOOS-Reject"]);
    addAlert("n_poos_pending_review", alertValues["NPOOS-Pending Review"]);
    addAlert("r_poos_reject", alertValues["RPOOS-Reject"]);
    addAlert("n_poos_other", alertValues["NPOOS-Others"]);
    addAlert("r_poos_fq", alertValues["RPOOS-FQ: FG Quality Failures"]);
    addAlert("r_poos_dm", alertValues["RPOOS-DM: Demand Planning Issue"]);
    addAlert("n_poos_dm", alertValues["NPOOS-DM: Demand Planning Issue"]);
    addAlert("demand_planning_issue", alertValues["Demand Planning Issue"]);

    addAlert("stos_to_cancel_from_dc", alertValues["STOs to Cancel from DC"]);
    addAlert("diverts_to_dc", alertValues["Diverts to DC"]);

    addAlert("diverts_to_dc", alertValues["Diverts to DC"]);
    addAlert(
      "High Accuracy- Awards Short",
      alertValues["High Accuracy- Awards Short"]
    );
    addAlert(
      "High Accuracy- No Awards",
      alertValues["High Accuracy- No Awards"]
    );

    addAlert("Capacity Breach", alertValues["Capacity Breach"]);
    addAlert(
      "Cost Increase vs Baseline",
      alertValues["Cost Increase vs Baseline"]
    );
    addAlert(
      "Outbound Dock Capacity Limit",
      alertValues["Outbound Dock Capacity Limit"]
    );
    addAlert(
      "Revenue Decrease vs Baseline",
      alertValues["Revenue Decrease vs Baseline"]
    );

    addAlert("cost_reduction", alertValues["Cost Reduction"]);
    //addAlert("Waste Risk", alertValues["Waste Risk"]);
    addAlert("over_capacity", alertValues["Over Capacity"]);
    addAlert("cof_improvement", alertValues["COF Improvement"]);

    addAlert(
      "Cancellations - above Upper limit",
      alertValues["Cancellations - above Upper limit"]
    );
    addAlert(
      "Exceptions - above Upper limit",
      alertValues["Exceptions - above Upper limit"]
    );
    addAlert(
      "Order Count - above upper bound",
      alertValues["Order Count - above upper bound"]
    );
    addAlert(
      "Order Count - below lower bound",
      alertValues["Order Count - below lower bound"]
    );
    addAlert(
      "Order Value - above upper bound",
      alertValues["Order Value - above upper bound"]
    );
    addAlert(
      "Order Value - below lower bound",
      alertValues["Order Value - below lower bound"]
    );
    addAlert("ATP To confirm Quantity", alertValues["ATP To confirm Quantity"]);
    addAlert("Confirm qty adjustment", alertValues["Confirm qty adjustment"]);
    addAlert("Low Payload or COF", alertValues["Low Payload or COF"]);

    addAlert("2S -Increase over 2 wks", alertValues["2S -Increase over 2 wks"]);
    addAlert("KE -Increase over 2 wks", alertValues["KE -Increase over 2 wks"]);
    addAlert("LS -Increase over 2 wks", alertValues["LS -Increase over 2 wks"]);
    addAlert("UK -Increase over 2 wks", alertValues["UK -Increase over 2 wks"]);
    addAlert("Wrong_reason_code", alertValues["Wrong_reason_code"]);
    addAlert(
      "Quantity Cuts  CX WoW Increase",
      alertValues["Quantity Cuts  CX WoW Increase"]
    );
    addAlert(
      "Late Loads CB WoW Increase",
      alertValues["Late Loads CB WoW Increase"]
    );
    addAlert(
      "Late Loads CF WoW Increase",
      alertValues["Late Loads CF WoW Increase"]
    );
    addAlert(
      "Quantity Cuts  3B WoW Increase",
      alertValues["Quantity Cuts  3B WoW Increase"]
    );
    addAlert(
      "Exception Y40 WoW Increase",
      alertValues["Exception Y40 WoW Increase"]
    );
    addAlert(
      "Late Loads (On-time) WoW Increase",
      alertValues["Late Loads (On-time) WoW Increase"]
    );
    addAlert(
      "Exception Y39 WoW Increase",
      alertValues["Exception Y39 WoW Increase"]
    );
    addAlert(
      "Late Loads AD WoW Increase",
      alertValues["Late Loads AD WoW Increase"]
    );
    addAlert(
      "Late Loads No Data WoW Increase",
      alertValues["Late Loads No Data WoW Increase"]
    );
    addAlert(
      "Late Loads AM WoW Increase",
      alertValues["Late Loads AM WoW Increase"]
    );

    addAlert("COST INCREASE MOM", alertValues["COST INCREASE MOM"]);
    addAlert("TRUCK SHORTAGE", alertValues["TRUCK SHORTAGE"]);
    addAlert("Rejected STR", alertValues["Rejected_STR"]);
    addAlert("Past Due STO", alertValues["Past_due_STO"]);

    return {
      alertAndThreshold,
      ...params,
    };
  }

  const handleSaveChanges = () => {
    console.log("alertValues>>>>>>>>>>>", alertValues);
    if (alertFile === 0) {
      setEditAlertLoading(true);
      const params = generateParams(alertValues, Network, DC);

      AlertService.bulkUpdateBasedOnAlertType(params, instance)
        .then((_data) => {
          setAlertValues({});
          // setAlertType([]);
        })
        .catch((error) => console.error("Error:", error))
        .finally(() => {
          //setEditAlertLoading(false);
          setOnsave(true);
        });
    } else if (alertFile === 1) {
      const params = { filter: {}, module: tabName };
      let filter = {};
      if (Network !== "") {
        filter.Network = Network;
      } else if (DC !== "") {
        filter.RecommendedDC = DC;
      }
      if (Object.keys(filter).length) {
        params.filter = filter;
      }
      bulkEditThresholdFileUpload(params);
      setOnsave(true);
    }
    setalertFile(-1);
    handleBulkEditClose();
  };

  const handleViewUpload = () => {
    if (fileData.length === 0) {
      return;
    }
    const { payloadIncrease, costReduction, payloadDecrease } = fileData[0];
    onFileData(fileData);
    handleSave({ payloadIncrease, costReduction, payloadDecrease });
    handleBulkEditClose();
  };

  const getAllAlertTypes = () => {
    setLoading(true);
    const params = {
      module: apiValue,
    };
    AlertService.fetchAllAlertsType(params, instance)
      .then((data) => {
        if (data?.data) {
          setAlertType(data?.data);
        }
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getAllAlertTypes();
  }, [tabName, Network, DC]);

  return (
    <BootstrapDialog
      onClose={handleBulkEditClose}
      aria-labelledby="customized-dialog-title"
      open={openBulkEdit}
    >
      <DialogTitle className={classes.dialogTitle}>
        <Typography className={classes.editTitle}>
          Edit Threshold for Alerts
        </Typography>
        <IconButton
          aria-label="close"
          onClick={handleBulkEditClose}
          sx={{ color: (theme) => theme.palette.grey[500] }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {loading ? (
        <div className={classes.loaderContainer}>
          <Loading />
        </div>
      ) : (
        <>
          <DialogContent className={classes.dialogContent}>
            <div>
              {alertType &&
                alertType?.map((item) => {
                  // Check if Alert_matrix is "cost_per_case" and replace it with "cost_per_case_increase"
                  const updatedAlertMatrix =
                    item?.Alert_matrix === "cost_per_case"
                      ? "cost_per_case_increase"
                      : item?.Alert_matrix || item?.Insight_Type;

                  return (
                    <div
                      className={classes.formContainer}
                      key={updatedAlertMatrix}
                    >
                      <Typography className={classes.formField}>
                        {formatColumnValue(updatedAlertMatrix)}
                      </Typography>
                      <TextField
                        hiddenLabel
                        id={`alert-${updatedAlertMatrix}`}
                        name={`alert-${updatedAlertMatrix}`}
                        value={alertValues[updatedAlertMatrix] || ""}
                        onChange={(e) =>
                          handleInputChange(e, updatedAlertMatrix)
                        }
                        variant="outlined"
                        size="small"
                        required={true}
                        className={classes.textField}
                        disabled={fileName ? true : false}
                      />
                    </div>
                  );
                })}
            </div>
            <div className="vertical-line">
              <div className="line"></div>
              <span className="or-text">OR</span>
            </div>
            <div className={classes.fileDiv}>
              <div
                className={`${classes.dottedBox} ${
                  dragging ? classes.draggingDottedBox : ""
                }`}
                onDragOver={handleDragOver}
                onDragEnter={() => setDragging(true)}
                onDragLeave={() => setDragging(false)}
                onDrop={handleDrop}
              >
                {fileName ? (
                  <>
                    <CheckCircleIcon className={classes.fileUploadedIcon} />
                    <Typography className={classes.fileUploadedText}>
                      File uploaded successfully
                    </Typography>
                    <Typography
                      component="a"
                      href="#"
                      className={classes.fileNameText}
                    >
                      {fileName}
                      <IconButton
                        onClick={handleRemoveFile}
                        aria-label="remove file"
                      >
                        <CancelIcon />
                      </IconButton>
                    </Typography>
                  </>
                ) : (
                  <>
                    <FileUploadOutlinedIcon
                      className={classes.uploadIcon}
                      disabled={hasInputValues}
                    />
                    <Typography
                      className={classes.drapDrop}
                      disabled={hasInputValues}
                    >
                      {dragging ? "Drop Here" : "Drag & Drop to upload"}
                    </Typography>
                    <Typography className={classes.or}>or</Typography>
                    <label htmlFor="file-input" style={{ height: "20px" }}>
                      <Button
                        variant="file"
                        component="span"
                        className={classes.browseFilesButton}
                        disabled={hasInputValues}
                      >
                        Browse Files
                      </Button>
                    </label>
                    {errorMessage && (
                      <Typography className={classes.browseFilesButton}>
                        {errorMessage}
                      </Typography>
                    )}
                    <input
                      type="file"
                      id="file-input"
                      accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      style={{ display: "none" }}
                      onChange={(e) => handleFileChosen(e.target.files[0])}
                    />
                  </>
                )}
              </div>
              {fileName && (
                <div className={classes.viewUploadButton}>
                  <Button
                    variant="outlined"
                    className={classes.viewButton}
                    onClick={handleViewUpload}
                  >
                    View uploaded thresholds
                  </Button>
                </div>
              )}
            </div>
          </DialogContent>

          <DialogActions className={classes.dialogActions}>
            <Button
              variant="text"
              onClick={() => handleClose()}
              className={classes.cancelButton}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => handleSaveChanges()}
              className={classes.saveButton}
            >
              Save
            </Button>
          </DialogActions>
        </>
      )}
    </BootstrapDialog>
  );
}
const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  periodType: state.filter.periodType,
  PL3: state.filter.PL3,
  date: state.filter.Date,
  Division: state.filter.Division,
  applyFilter: state.filter.applyFilter,
  role: state.login.role,
});

export default connect(mapStateToProps)(BulkEdit);
